export const fundOrderSideOptions = [
  { value: 'buy', label: 'Mua' },
  { value: 'sell', label: 'Bán' },
  { value: 'transfer_buy', label: 'Mua chuyển đổi' },
  { value: 'transfer_sell', label: 'Bán chuyển đổi' },
];

export const fundOrderSideLabels = {
  buy: 'Mua',
  sell: 'Bán',
  redistribute: 'Redistribute',
  transfer_buy: 'Mua chuyển đổi',
  transfer_sell: 'Bán chuyển đổi',
};

export const fundOrderSideColors = {
  buy: 'green',
  sell: 'blue',
  transfer_buy: 'cyan',
  transfer_sell: 'red',
};
